import { Injectable } from '@angular/core';
import { ApiConfigService } from '../../../shared-services/api-config.service';
import { Observable } from 'rxjs';
import { SubscriptionPacketDto } from '../../../dtos/subscriptionPacketDto';
import { switchMap } from 'rxjs/operators';
import { UserDto } from '../../../dtos/userDto';
import { iif } from 'rxjs';
import { of } from 'rxjs';
import { UserDataService } from '../data-storage/user-data.service';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';
import { SiteDto } from '../../../dtos/siteDto';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionPacketsService {

  constructor(private apiConfigService: ApiConfigService, private userDataService:UserDataService) { }

  getSubscriptionPackets(siteId:number):Observable<SubscriptionPacketDto[]>{
    return this.apiConfigService.get<SubscriptionPacketDto[]>("api/subscription/packets/"+siteId);
  }

  getSinglePacket(packetId){
    return this.apiConfigService.get<SubscriptionPacketDto>("api/subscription/packet/"+packetId);
  }

  buyPacket(responseToken){
    return this.apiConfigService.post("api/subscription/buy/",responseToken);
  }

  checkUserPacket(seotitle){
    return this.userDataService.currentUser.pipe(
        switchMap((user:UserDto) =>
            iif(
                () => user.id >0,
                this.checkOrder(seotitle),
                of(false)
            )
        )
    )
  }

  isSitePurchased(site: SiteDto){
      return this.userDataService.getUser().id ? this.userDataService.getUser().sitePurchased.includes(site.id) : false;
  }

  getTotalPrice(arrayPackets:SubscriptionPacketDto[], withDiscount?){
      let totalValue = 0;
      for (let packet of arrayPackets){
          totalValue += packet.price;
      }
      if(withDiscount){
          totalValue = totalValue - (totalValue * 15) /100;
      }
      return totalValue;
  }

  getDiscount(siteLength){
      const discount = 15 * (siteLength - 1);
      return discount > 60 ? 60 : discount;
  }

  private checkOrder(monumentSeo): Observable<boolean> {
    return this.apiConfigService.get('api/order/check/'+monumentSeo)
        .pipe(
            map(() => true),
            catchError(err => {
              return of(false);
            })
        );
  }
}
